import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "../Carrusel/Carrusel.css";

const API_URL = process.env.REACT_APP_CMS_API_URL || 'http://localhost:5001/api';
const MEDIA_URL = (process.env.REACT_APP_CMS_API_URL || 'http://localhost:5001/api').replace(/\/api$/, '');

const Carrusel = () => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await fetch(`${API_URL}/banners`);
        const data = await response.json();
        setBanners(data);
      } catch (error) {
        console.error('Error al cargar banners:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchBanners();
  }, []);

  if (loading) {
    return (
      <div className="carrusel-container" style={{ minHeight: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <p>Cargando...</p>
      </div>
    );
  }

  if (banners.length === 0) {
    return null; // No mostrar nada si no hay banners
  }

  return (
    <div className="carrusel-container">
      <Swiper
        modules={[Navigation, Autoplay]}
        navigation
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        loop={true}
        className="mySwiper"
      >
        {banners.map((banner) => (
          <SwiperSlide key={banner.id}>
            {banner.link_url ? (
              <a href={banner.link_url} target="_blank" rel="noopener noreferrer">
                <img 
                  src={`${MEDIA_URL}${banner.image_url}`} 
                  alt={banner.title_es || 'Banner'} 
                />
                {(banner.title_es || banner.subtitle_es) && (
                  <div className="banner-text-overlay">
                    {banner.title_es && <h2>{banner.title_es}</h2>}
                    {banner.subtitle_es && <p>{banner.subtitle_es}</p>}
                  </div>
                )}
              </a>
            ) : (
              <>
                <img 
                  src={`${MEDIA_URL}${banner.image_url}`} 
                  alt={banner.title_es || 'Banner'} 
                />
                {(banner.title_es || banner.subtitle_es) && (
                  <div className="banner-text-overlay">
                    {banner.title_es && <h2>{banner.title_es}</h2>}
                    {banner.subtitle_es && <p>{banner.subtitle_es}</p>}
                  </div>
                )}
              </>
            )}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Carrusel;
